import styled from 'styled-components';
import SistemaList from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin: 0;
  width: 100%;
  font-size: 12px;
  background: #fff;

  p, pre {
    font-family: 'Nunito', 'cursive';
  }

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .barra-sup {
    background: #2ED3B5;
    width: 100%;
    height: 8px;
    content: "";
  }

  .header {
    padding: 1em 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    img {
      width: 6em;
    }

    .text {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .titulo {
        font-size: 1em;
        color: ${Colors.Color3};
      }

      .titulo-relatorio {
        font-size: 1.3em;
        color: ${Colors.Color3};
      }

      .titulo-data {
        font-size: 1em;
        color: ${Colors.Color7};
      }
    }
  }
  
  .body {
    padding: 0em 0.4em;

    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .text {
        .titulo {
          font-size: 1.2em;
          color: #5269A7;
        }

        .sub-titulo {
          font-size: 2em;
          color: #A4A2A2;
        }
      }
    }

    .mid {
      display: flex;
      flex-direction: row;
      align-items: align-start;
      justify-content: space-between;
      width: 100%;
      border-radius: 6px;
      background: ${Colors.Color8};
      padding: 1.5em;

      .rigth {
        align-items: flex-end;
      }
      
      .col {
        display: flex;
        flex-direction: column;
        width: 100%;
        border-radius: 6px;
        /* padding: 0.5em; */

        .linha {
          display: flex;
          flex-direction: row;
          margin-bottom: 0.8em;
          
          .titulo {
            font-size: 1.1em !important;
            color: ${Colors.Color3} !important;
            font-weight: 600;
          }

          .valor {
            font-size: 1.1em !important;
            color: ${Colors.Color7} !important;
            margin-left: 0.2em;
            font-weight: 400;
          }
        }
      }
      
    }
  }
`;

export const ContainerComm = styled(SistemaList)`
  height: 100%;
  overflow: auto;
`;

export const ThisProgress = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  content: "";
  width: ${props => props?.width};
  height: 0.6em;
  border-radius: 1em;
  background: ${props => props?.backgound};
`;

export const ContainerTable = styled.div`
  padding: 0em;
  width: 100%;
  background: #FFFFFF;
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  table-layout: auto;
  width: 100%;

  thead {
    background: #F8F8F8;
  }

  th {
    /* TABLE */
    color: #969AAA;
    height: 3em;
    font-weight: 800;
    font-size: 0.8em;
  }

  th:first-child {
    border-radius: 0.72em 0 0 0.72em;
  }

  th:last-child {
    border-radius: 0 0.72em 0.72em 0;
  }

  td {
    /* border-bottom: solid 0.1em #f3f3f3; */
    min-height: 2.6em;
    font-weight: 400;
    font-size: 0.72em;
    color: #969AAA;

    :empty {
      height: 3.1em;
    }
  }

  td,
  th {
    white-space: nowrap;
    /* overflow: hidden;
    text-overflow: ellipsis; */
    line-break: none;
    padding: 1em 0.56em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    text-align: left;
  }

  tbody {
    tr {
      cursor: pointer;
      // border: 2px solid #F8F8F8;
    }

    tr.back {
      background: #F8F8F8 !important;
    }

    td:first-child {
      border-radius: 0.72em 0 0 0.72em;
    }

    td:last-child {
      border-radius: 0 0.72em 0.72em 0;
    }
  }

  .text-center {
    text-align: center;
  }

  .truncate {
    width: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .col-w-1 {
    max-width: 5em;
    min-width: 6em;
    width: 5em;
  }

  .col-w-2 {
    max-width: 10em;
    min-width: 10em;
    width: 10em;
  }

  .col-w-3 {
    max-width: 15em;
    min-width: 15em;
    width: 15em;
  }

  .col-w-4 {
    max-width: 20em;
    min-width: 20em;
    width: 20em;
  }

  .col-w-5 {
    max-width: 25em;
    min-width: 25em;
    width: 25em;
  }

  .col-w-6 {
    max-width: 30em;
    min-width: 30em;
    width: 30em;
  }

  .col-w-7 {
    max-width: 35em;
    min-width: 35em;
    width: 35em;
  }

  .col-w-8 {
    max-width: 40em;
    min-width: 40em;
    width: 40em;
  }

  .col-w-9 {
    max-width: 45em;
    min-width: 45em;
    width: 45em;
  }

  .col-w-10 {
    max-width: 50em;
    min-width: 50em;
    width: 50em;
  }
`;

export const ThisTr = styled.div`
  
  tr {
    background: #F8F8F8 !important;
  }

`;